import { apply, call, put } from 'redux-saga/effects';
import Http from '../../../libs/Http';
import { getDataTimeString } from '../../../libs/Util';
import history from "../../../history";

export function* fetchChannels(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  const data = yield call(Http.get, '/channels/list', {
    query: {
      page: payload.page,
      filters: JSON.stringify(payload.filters),
    }
  });
  yield put({
    // $global: true,
    type: 'SET_CHANNELS',
    payload: data
  });

  yield put({ $global: true, type: 'STOP_LOADER' });
}

export function* updateChannelDetails(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  const data = yield call(Http.post, '/channels/update', {
    body: {
      _id: payload._id,
      data: payload.data,
    }
  });
  yield fetchChannels(action);
  yield put({ type: 'CHANNEL_UPDATED', payload });
  yield put({ $global: true, type: 'STOP_LOADER' });
}

export function* exportChannelsCSV(action) {
  const { payload, meta } = action;


  yield put({ $global: true, type: 'START_LOADER' });

  const currentDate = getDataTimeString();
  const filename = `${payload.filters.created || 'NO-DATE'} - ${payload.filters.accounts.join('+')} - ${payload.exportType} - channels - export.csv`;

  yield call(Http.get, '/channels/exportCSV', {
    query: {
      exportType: payload.exportType,
      filters: JSON.stringify(payload.filters),
      filename: filename,
    }
  });

  yield put({ $global: true, type: 'STOP_LOADER' });
  yield apply(history, history.push, ['/workArea/files']);
}

export default function*({ takeFirst }) {
  yield [
    takeFirst('FETCH_CHANNELS', fetchChannels),
    takeFirst('UPDATE_CHANNEL_DETAILS', updateChannelDetails),
    takeFirst('EXPORT_CHANNELS_CSV', exportChannelsCSV),
  ];
}



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Channels/Channels.sagas.js